import { EntityModel } from '@/interfaces'
import {
  ALL_HEADER_SLIDER_BLOCK_SLIDES_QUERY,
  CREATE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION,
  DELETE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION,
  FORCE_DELETE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION,
  SINGLE_HEADER_SLIDER_BLOCK_SLIDE_QUERY,
  UPDATE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'
import linkEntity from '@/entities/link/entity'

const cmsHeaderSliderBlockSlideModel: EntityModel = {
  name: 'headerSliderBlockSlide',
  namePlural: 'headerSliderBlockSlides',
  uniqueName: 'cmsHeaderSliderBlockSlide',
  uniqueNamePlural: 'cmsHeaderSliderBlockSlides',
  path: 'cms/blocks/header_slider_block_slide',
  baseUrl: '/cms/blocks/header_slider_block_slides',
  translationPrefix: 'entities:cmsHeaderSliderBlockSlide.',
  getDisplayName: (values: any) => {
    return values.title && values.title.length > 0 ? values.title : 'Slide'
  },
  gql: {
    getAll: ALL_HEADER_SLIDER_BLOCK_SLIDES_QUERY,
    getSingle: SINGLE_HEADER_SLIDER_BLOCK_SLIDE_QUERY,
    create: CREATE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION,
    update: UPDATE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION,
    delete: DELETE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION,
    forceDelete: FORCE_DELETE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION,
  },
  attributes: {
    image: {
      name: 'image',
      label: 'entities:cmsHeaderSliderBlockSlide.attributes.image.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    title: {
      name: 'title',
      label: 'entities:cmsHeaderSliderBlockSlide.attributes.title.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    text: {
      name: 'text',
      label: 'entities:cmsHeaderSliderBlockSlide.attributes.text.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    link: {
      name: 'link',
      label: 'entities:cmsHeaderSliderBlockSlide.attributes.link.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return linkEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsHeaderSliderBlockSlideModel
